<template>
  <ib-guided-tour
    tour-name="businessPlanTour"
    :steps="tourSteps"
    :show-intro-dialog="showIntroDialog"
    :intro-delay="1000"
    @tour-start="$emit('tour-start')"
    @tour-end="$emit('tour-end')"
    @intro-skip="$emit('intro-skip')"
  >
    <template #intro-image>
      <img src="@/assets/img/onboarding/idea.svg" alt="" style="width: 125px;">
    </template>
    <template #intro>
      <h1 class="text-center mb-2 font-outfit-semi-bold">
        {{ $t('pages.businessPlan.tour.introTitle') }}
      </h1>
      <p class="text-center" style="font-size: 18px;">
        {{ $t('pages.businessPlan.tour.introText') }}
      </p>
    </template>
  </ib-guided-tour>
</template>

<script>
export default {
  name: 'BusinessPlanTour',

  props: {
    showIntroDialog: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    tourSteps () {
      return [
        {
          target: '.accordion-item:nth-child(3)',
          header: { title: this.$t('pages.businessPlan.tour.step1Title') },
          content: this.$t('pages.businessPlan.tour.step1Content'),
          params: {
            placement: 'left',
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: '.journal-sidebar',
          header: { title: this.$t('pages.businessPlan.tour.step2Title') },
          content: this.$t('pages.businessPlan.tour.step2Content'),
          params: {
            placement: 'left',
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: '.el-button',
          header: { title: this.$t('pages.businessPlan.tour.step3Title') },
          content: this.$t('pages.businessPlan.tour.step3Content'),
          params: {
            placement: 'left',
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: '.align-self-end > .d-flex',
          header: { title: this.$t('pages.businessPlan.tour.step4Title') },
          content: this.$t('pages.businessPlan.tour.step4Content'),
          params: {
            placement: 'bottom',
            enableScrolling: false,
            highlight: true
          }
        }
      ]
    }
  }
}
</script>

<style lang="scss">
body.v-tour--businessPlanTour {
  .page-header::after,
  .journal-content-wrapper::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 9999;
    pointer-events: none;
  }

  .page-content {
    background: rgba(0, 0, 0, 0.4);
  }

  &--step-3 {
    .page-header::after,
    .journal-content-wrapper::after {
      display: none;
    }

    .page-content {
      background: transparent;
    }
  }
}
</style>
